import { deactivateUserAsync } from "State/Users/Detail/DeactivateUserState";
import { type ActionType, createReducer } from "typesafe-actions";

type UserState = {
  isDeactivatingUser: boolean;
};

type UserAction = ActionType<typeof deactivateUserAsync>;

export const userReducer = createReducer<UserState, UserAction>({
  isDeactivatingUser: false,
})
  .handleAction(deactivateUserAsync.request, (state) => {
    return { ...state, isDeactivatingUser: true };
  })
  .handleAction(deactivateUserAsync.success, (state, _action) => {
    return { ...state, isDeactivatingUser: false };
  })
  .handleAction(deactivateUserAsync.failure, (state, _action) => {
    return {
      ...state,
      isDeactivatingUser: false,
    };
  });
